<template>
	<v-row>
		<v-col cols="12" class="actions-col">
			<div class="actions">
				<v-btn
					depressed
					outlined
					@click="download"
					:loading="isDownloading"
					:disabled="isDownloading"
				>
					<v-icon class="mr-1" v-if="!isDownloading">mdi-download</v-icon>
					{{ isDownloading ? 'Downloading...' : 'Download' }}
				</v-btn>
				<v-btn depressed outlined @click="showPrintModal = !showPrintModal"
					><v-icon class="mr-1">mdi-printer</v-icon> Print
				</v-btn>
				<v-btn depressed outlined @click="$router.back()">Cancel</v-btn>
			</div>
		</v-col>

		<v-col v-show="false" cols="12">
			<article class="print">
				<div class="print-wrapper">
					<!-- Page identification footer for pagination - PagedJS moves this to margin -->
					<div class="page-id-footer">
						<span class="doc-id">{{ isQuote ? 'Q' : 'SO' }}-{{ isQuote ? printInfo.quoteNumber : printInfo.orderNumber }}</span>
						<span class="separator"> | </span>
						<span class="page-number"></span>
						<span class="separator"> | </span>
						<span class="printed-info">Printed on {{ currentDate }} at {{ currentTime }} {{ printedBy }}</span>
					</div>
					<section class="print-heading">
						<div class="print-heading-left">
							<p>
								<b>TeamLeader</b>
							</p>

							<p>
								2901 Summit Ave. #300
								<br />
								Plano, TX 75074
							</p>

							<p>Phone: 1-877-365-7555</p>
						</div>

						<div class="print-heading-center">
							<div class="print-heading-logo">
								<img
									src="data:image/svg+xml;base64,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"
									alt="teamleader logo"
								/>
							</div>
						</div>

						<div class="print-heading-right">
							<span class="print-heading-type">{{ printType }}</span>

							<p>
								<b>{{ isQuote ? printInfo.quoteNumber : printInfo.orderNumber }}</b>
							</p>

							<!-- <p>Page 1</p> -->
							<div id="print-header">Page</div>

							<p v-if="printInfo.schoolPo" class="school-po">
								School PO #: {{ printInfo.schoolPo }}
							</p>
						</div>
					</section>

					<section class="print-info">
						<div class="print-info-container-split">
							<table>
								<thead>
									<tr>
										<th>Sold To: (Customer # {{ printInfo.customerNumber }})</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>
											<p>{{ computedAddress.contactName }}</p>
											<p>{{ computedAddress.organization }}</p>
											<p v-if="computedAddress.department">{{ computedAddress.department }}</p>
											<p>{{ computedAddress.address }}</p>
											<p class="addr-city-state">{{ computedAddress.cityState }}</p>

											<p v-if="computedAddress.contactEmail" style="font-size: 9pt">{{ computedAddress.contactEmail }}</p>
											<p v-if="computedAddress.contactWorkPhone" style="font-size: 9pt">Work: {{ computedAddress.contactWorkPhone }}</p>
											<p v-if="computedAddress.contactCellPhone" style="font-size: 9pt">Cell: {{ computedAddress.contactCellPhone }}</p>
										</td>
									</tr>
								</tbody>
							</table>
						</div>

						<div class="print-info-container-split">
							<table>
								<thead>
									<tr>
										<th>Ship To: (Customer # {{ printInfo.customerNumber }})</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>
											<p>{{ computedShipTo.contactName }}</p>
											<p>{{ computedShipTo.organization }}</p>
											<p>{{ computedShipTo.address }}</p>
											<p class="addr-city-state">{{ computedShipTo.cityState }}</p>

											<p v-if="computedShipTo.contactEmail" style="font-size: 9pt">{{ computedShipTo.contactEmail }}</p>
											<p v-if="computedShipTo.contactWorkPhone" style="font-size: 9pt">Work: {{ computedShipTo.contactWorkPhone }}</p>
											<p v-if="computedShipTo.contactCellPhone" style="font-size: 9pt">Cell: {{ computedShipTo.contactCellPhone }}</p>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</section>

					<section class="print-info">
						<div class="print-info-container-full">
							<table>
								<thead>
									<tr>
										<th>{{ dateLabel }}</th>
										<th>Payment Terms</th>
										<th>Rep</th>
										<th>Order Source</th>
										<th>Ship Via</th>
										<th>Referral</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>
											<p>{{ formatDate(displayDate) }}</p>
										</td>
										<td>
											<p>{{ renderPaymentTerms(printInfo.paymentTermsId) }}</p>
										</td>
										<td>
											<p>{{ renderSalesRep(printInfo.salesRepId, "name") }}</p>
										</td>
										<td>
											<p>{{ printInfo.attribution }}</p>
										</td>
										<td>
											<p>{{ renderShippingMethod(printInfo.shippingMethodId) }}</p>
										</td>
										<td>
											<p>&nbsp;</p>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</section>

					<section class="print-items">
						<div class="print-items-container">
							<table>
								<thead>
									<tr>
										<th>Line #</th>
										<th>Item #</th>
										<th>Description</th>
										<th>Qty Ord</th>
										<th>Qty Ship</th>
										<th>Each</th>
										<th>Extended</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(lineItem, i) in computedItemsTable" :key="i">
										<td>{{ i + 1 }}</td>
										<td>
											<!-- Show style code for regular items and manual attachments (Imprint/Lettering/Monogram/Stones), hide for auto-added braids and other sub-item categories -->
											<p v-if="$systemCategories.shouldShowStyleCode(lineItem)" class="print-items-title">{{ lineItem.styleCode }}</p>
											<p v-if="lineItem?.shippingDate && $systemCategories.shouldShowStyleCode(lineItem)" class="print-items-shipped">
												(Shipped {{ formatDate(lineItem.shippingDate) }})
											</p>
										</td>
										<td>
											<p class="print-items-title">
												{{ lineItem.description }}
											</p>
											<p
												style="font-weight: normal; font-style: italic"
												v-if="lineItem.note"
												v-html="formatNewLines(lineItem.note)"
											></p>
											<p v-if="lineItem.braidPosition" class="print-items-title">
												{{ lineItem.braidPosition }}
											</p>
											<template
												v-if="
													(lineItem.colorSelections && lineItem.colorSelections.length > 0) ||
													(lineItem.freeTextSelections && lineItem.freeTextSelections.length > 0)
												"
											>
												<p
													v-for="(color, colorIndex) in mergeAndSortSelections(lineItem)"
													:key="colorIndex"
												>
													{{ renderColorOption(color, lineItem.colorOptions) }}
												</p>
											</template>
											<span v-if="lineItem.matchPreviousPoNumber">
												Previous PO: #{{ lineItem.matchPreviousPoNumber }}
											</span>
											<template v-if="lineItem.lettering">
												<p>
													{{ lineItem.lettering.description }}
												</p>
												<p>"{{ lineItem.lettering.text }}"</p>
											</template>
											<p v-if="lineItem.mergedSortedSizes && lineItem.mergedSortedSizes.length > 0">
												<template v-for="(size, sizeIndex) in lineItem.mergedSortedSizes">
													<span :key="sizeIndex" class="size-item">{{ size }}<template v-if="sizeIndex < lineItem.mergedSortedSizes.length - 1">, </template></span>
												</template>
											</p>
											<p v-if="(lineItem.sizeUpCharge || 0) > 0">
												Size Upcharge (+${{ lineItem.sizeUpCharge.toFixed(2) }})
											</p>
											<p v-if="(lineItem.upCharge || 0) > 0">
												{{ lineItem.upChargeDescription || "Package Upgrade" }} (+${{
													lineItem.upCharge.toFixed(2)
												}})
											</p>
											<p v-if="lineItem.isManuallyOverridden && (lineItem.quantityOverride || 0) > 0 && (lineItem.extraItemsPrice || 0) > 0">
												Quantity Upcharge (+{{ lineItem.quantityOverride }} @ ${{ lineItem.price ? lineItem.price.toFixed(2) : '0.00' }})
											</p>
										</td>
										<td>
											<p v-if="!(lineItem._isChild && lineItem.braidPosition)" class="print-items-value">{{ lineItem.quantity }}</p>
										</td>
										<td>
											<p v-if="!(lineItem._isChild && lineItem.braidPosition)" class="print-items-value">
												{{ lineItem.status === "Shipped" ? lineItem.quantity : 0 }}
											</p>
										</td>
										<td>
											<p class="print-items-value">
												<del v-if="lineItem.includePrice">{{ renderPrice(lineItem.price) }}</del>
												<template v-else>{{ renderPrice(lineItem.price) }}</template>
											</p>
											<p
												v-if="
													(lineItem.colorUpCharges || 0) +
														(lineItem.sizeUpCharge || 0) +
														(lineItem.upCharge || 0) +
														(lineItem.extraItemsPrice || 0) >
													0
												"
												class="print-items-value"
											>
												(+${{
													(
														(lineItem.colorUpCharges || 0) +
														(lineItem.sizeUpCharge || 0) +
														(lineItem.upCharge || 0) +
														(lineItem.extraItemsPrice || 0)
													).toFixed(2)
												}})
											</p>
										</td>
										<td>
											<p class="print-items-value">{{ getItemPrice(lineItem)[1] }}</p>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</section>
					<section class="print-rep-prices">
						<table class="print-rep-prices-table" style="width: 100%">
							<tr>
								<td>
									<div class="print-rep-info-container">
										Please email {{ renderSalesRep(printInfo.salesRepId, "name") }} at
										{{ renderSalesRep(printInfo.salesRepId, "email") }} with any questions.
										<!-- Online payment QR + typed link, invoices only (#1472). Rendered as real DOM
										     with a data-URI image so it survives the innerHTML serialization that
										     feeds both the preview iframe and the server-side PDF/print job. -->
										<div v-if="printType === 'INVOICE'" class="print-pay-online">
											<img
												v-if="payQrDataUrl"
												:src="payQrDataUrl"
												:alt="`QR code for ${paymentUrlDisplay}`"
												class="print-pay-online-qr"
											/>
											<div class="print-pay-online-text">
												<p class="print-pay-online-title">Pay online</p>
												<p>
													Scan the code or visit
													<a :href="paymentUrl">{{ paymentUrlDisplay }}</a>
												</p>
											</div>
										</div>
									</div>
								</td>
								<td>
									<div class="print-prices-container print-table-price" style="float: right">
										<table>
											<tr>
												<td class="print-table-price-rowLabel">Subtotal</td>
												<td>{{ renderPrice(printInfo.printPrices.computedSubtotal) }}</td>
											</tr>
											<tr>
												<td class="print-table-price-rowLabel">S&H</td>
												<td>{{ renderPrice(printInfo.printPrices.shippingAndHandling) }}</td>
											</tr>
											<tr v-if="printInfo.printPrices.shippingAndHandlingDiscount !== 0">
												<td class="print-table-price-rowLabel">S&H Discount</td>
												<td>
													{{ renderPrice(printInfo.printPrices.shippingAndHandlingDiscount) }}
												</td>
											</tr>
											<tr>
												<td class="print-table-price-rowLabel">
													Tax
												</td>
												<td>{{ renderPrice(printInfo.printPrices.computedTaxAmount) }}</td>
											</tr>
											<tr>
												<td class="print-table-price-rowLabel">Order Total</td>
												<td>{{ renderPrice(printInfo.printPrices.computedOrdertotal) }}</td>
											</tr>
											<tr>
												<td class="print-table-price-rowLabel">Payments</td>
												<td>{{ renderPrice(printInfo.printPrices.computedPayments) }}</td>
											</tr>
											<tr>
												<td class="print-table-price-rowLabel">Balance</td>
												<td>{{ renderPrice(printInfo.printPrices.computedBalance) }}</td>
											</tr>
										</table>
									</div>
								</td>
							</tr>
						</table>
					</section>
					<section class="print-payments">
						<div class="print-payments-container">
							<table class="print-payments-table">
								<thead>
									<tr>
										<th>Pmt Date</th>
										<th>Pmt Type</th>
										<th>Amount</th>
										<th>Doc #</th>
										<th>Company</th>
										<th>Name</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(payment, i) in printInfo.payments" :key="i">
										<td>{{ formatDate(payment.paymentDate) }}</td>
										<td>{{ renderPaymentMethod(payment.paymentMethodId) }}</td>
										<td>{{ renderPrice(payment.amount) }}</td>
										<td>{{ payment.referenceNumber }}</td>
										<td>{{ payment.schoolOrOrganization }}</td>
										<td>{{ payment.name }}</td>
									</tr>
								</tbody>
							</table>
						</div>
					</section>

					<!-- Print info now included in page-id-footer which appears on every page -->
				</div>
			</article>
		</v-col>

		<!-- render live print pages from the print article -->
		<v-col cols="12" class="d-flex">
			<iframe id="print-frame"></iframe>
		</v-col>

		<!-- Snackbar for notifications -->
		<v-snackbar v-model="snackbar.show" :color="snackbar.color" :timeout="snackbar.timeout" top>
			<span class="text-h6">{{ snackbar.text || snackbar.message }}</span>
			<template v-slot:action="{ attrs }">
				<v-btn text v-bind="attrs" @click="snackbar.show = false">Close</v-btn>
			</template>
		</v-snackbar>

		<v-overlay :dark="false" :absolute="false" :value="showPrintModal">
			<div class="input-modal print-modal">
				<div class="input-modal-header justify-space-between">
					<span class="ml-3">Print</span>
					<v-btn icon @click="showPrintModal = false">
						<v-icon v-text="'mdi-close'"></v-icon>
					</v-btn>
				</div>
				<div class="input-modal-content">
					<div class="print-modal-form">
						<div class="form-input">
							<label>Printer:</label>
							<v-select
								v-model="printerSelection"
								:items="printers"
								item-text="text"
								item-value="printerId"
								dense
								outlined
								hide-detail
							></v-select>
						</div>
						<div class="form-input">
							<label>Copies:</label>
							<v-text-field
								class="number-input"
								outlined
								dense
								hide-details="auto"
								v-model="copies"
								type="number"
								min="0"
							></v-text-field>
						</div>
						<div class="form-input">
							<label>Message:</label>
							<v-textarea
								v-model="printMessage"
								dense
								outlined
								hide-details="auto"
								rows="5"
								placeholder="Add optional message or notes for this print job"
								class="message-input"
							></v-textarea>
						</div>
					</div>

					<div class="input-modal-content-actions">
						<v-spacer></v-spacer>
						<div class="button-group">
							<v-btn text @click="showPrintModal = false" :disabled="isPrinting" class="mr-2">
								Cancel
							</v-btn>
							<v-btn
								color="primary"
								depressed
								@click="print()"
								:loading="isPrinting"
								:disabled="isPrinting || !isFormValid"
							>
								<v-icon left>mdi-printer</v-icon>
								Print
							</v-btn>
						</div>
					</div>
					<v-alert v-if="printResult.show" dense text :type="printResult.type" class="mt-3">
						{{ printResult.message }}
					</v-alert>
				</div>
			</div>
		</v-overlay>
	</v-row>
</template>

<script>
import gql from "graphql-tag";
import { getItemPrice, renderPrice } from "@/helpers/PricingCalculator";
import { dedupeSelections } from "@/helpers/selectionHelper";
import queries from "../../gql/queries";
import { pagedJSService } from "@/services/PagedJSService";
import QRCode from "qrcode";
import { PAYMENT_URL, PAYMENT_URL_DISPLAY } from "@/helpers/constant";

export default {
	name: "SalesPrintTemplate",
	props: {
		printType: {
			type: String,
			default: "No Type Specified",
		},
		printInfo: {
			type: Object,
			default() {
				return {};
			},
		},
		isQuote: {
			type: Boolean,
			default: true,
		},
	},
	data() {
		return {
			paymentUrl: PAYMENT_URL,
			paymentUrlDisplay: PAYMENT_URL_DISPLAY,
			payQrDataUrl: null,
			payQrReady: null,
			attribuitions: [
				{ text: "New", attributionId: 1 },
				{ text: "Reorder", attributionId: 2 },
				{ text: "Dealer", attributionId: 3 },
				{ text: "Rep", attributionId: 4 },
				{ text: "E-commission", attributionId: 5 },
				{ text: "Outside Rep", attributionId: 6 },
				{ text: "Web Page", attributionId: 7 },
				{ text: "Unknown", attributionId: 8 },
				{ text: "Return", attributionId: 9 },
			],
			salesReps: [],
			shippingMethods: [],
			showPrintModal: false,
			printMessage: "",
			messages: [],
			printerSelection: "",
			printers: [],
			copies: 1,
			isPrinting: false,
			isDownloading: false,
			printResult: {
				show: false,
				type: "success",
				message: "",
			},
			printJobId: null,
			snackbar: {
				show: false,
				color: "success",
				text: "",
				timeout: 5000,
			},
			currentDate: this.getCurrentDate(),
			currentTime: this.getCurrentTime(),
		};
	},
	apollo: {
		messages: {
			query() {
				return gql`
					query {
						message(
							skip: 0
							take: 15
							order: { sequence: ASC }
							where: { orderTypeId: { eq: 2 } }
						) {
							items {
								messageId
								messageIdLabel
								messageContent
								orderTypeId
								sequence
							}
						}
					}
				`;
			},
			update(data) {
				return data.message.items;
			},
		},
		paymentTerms: {
			query: queries.GET_PAYMENT_TERMS,
			update: (data) => data.paymentTerms.items,
		},
		shippingMethods: {
			query() {
				return gql`
					query {
						shippingMethods(take: 500) {
							items {
								shippingMethodId
								shippingMethodName
							}
						}
					}
				`;
			},
			update: (data) => data.shippingMethods.items,
		},
	},
	methods: {
		getItemPrice,
		renderPrice,

		formatDate(date) {
			if (!date) return "";

			date = date.substring(0, 10);
			const [year, month, day] = date.split("-");
			return `${month}/${day}/${year}`;
		},

		getCurrentDate() {
			// Use Central Time (America/Chicago) for consistent timestamps
			const now = new Date();
			return now.toLocaleDateString('en-US', {
				timeZone: 'America/Chicago',
				month: 'numeric',
				day: 'numeric',
				year: '2-digit'
			});
		},

		getCurrentTime() {
			// Use Central Time (America/Chicago) for consistent timestamps
			const now = new Date();
			return now.toLocaleTimeString('en-US', {
				timeZone: 'America/Chicago',
				hour: 'numeric',
				minute: '2-digit',
				hour12: true
			}).toLowerCase();
		},

		renderSalesRep(salesRepId, key) {
			let repById = this.printInfo.salesReps.find((r) => r.salesRepId == salesRepId);
			if (repById) {
				if (key === "name") {
					return repById.name;
				}
				if (key === "email") {
					return repById.email;
				}
				if (key === "phoneNumber") {
					return repById.phoneNumber;
				}
			} else {
				return null;
			}
		},

		renderPaymentMethod(paymentMethodId) {
			let paymentMethodById = this.printInfo.paymentMethods.find(
				(s) => s.paymentMethodId == paymentMethodId
			);
			return paymentMethodById ? paymentMethodById.paymentMethodName.toUpperCase() : null;
		},

		renderShippingMethod(shippingMethodId) {
			let shippingById = this.printInfo.shippingMethods.find(
				(s) => s.shippingMethodId == shippingMethodId
			);
			return shippingById ? shippingById.shippingMethodName : null;
		},

		renderPaymentTerms(paymentTermsId) {
			let paymentById = this.printInfo.paymentTerms.find((s) => s.paymentTermsId == paymentTermsId);
			return paymentById ? paymentById.paymentTermsName.toUpperCase() : null;
		},

		renderColorOption(color, colorOptions) {
			// Build a complete map of colorId -> color info from colorOptions
			let colorObj = {};
			colorOptions.forEach((option) => {
				const colorDescription = option.description;
				const colorOption = option.name;
				option.colorPalettes?.forEach((colorPalette) => {
					colorPalette.colors?.forEach((colorDetail) => {
						colorObj[colorDetail.colorId] = { ...colorDetail, colorDescription, colorOption };
					});
				});
			});

			if (color.colorOptionId) {
				let optionById = colorOptions.find((c) => c.colorOptionId == color.colorOptionId);
				if (optionById) {
					// Look up the color description from the colorObj map using colorId
					const colorDetail = colorObj[color.colorId];
					const colorName = colorDetail?.description || color.description || color.colorName || color.text;

					let result = optionById.description
						? `${optionById.name}:${optionById.description}:${colorName}`
						: `${optionById.name}:${colorName}`;

					// Append the upCharge if it exists and is greater than 0
					if (color.upCharge && color.upCharge > 0) {
						result += ` (+$${color.upCharge.toFixed(2)})`;
					}
					return result;
				} else {
					return null;
				}
			} else {
				const detailedColor = colorObj[color.colorId];
				if (detailedColor) {
					// Use description from colorObj lookup
					let result = `${detailedColor.colorOption}:${detailedColor.colorDescription}:${detailedColor.description}`;

					// Append the upCharge if it exists and is greater than 0
					if (color.upCharge && color.upCharge > 0) {
						result += ` (+$${color.upCharge.toFixed(2)})`;
					}
					return result;
				} else {
					return "";
				}
			}
		},

		renderSizes(sizeSelections, isSpecialSize) {
			let listOfSizes = [];

			sizeSelections.forEach((size) => {
				const sizeString = `${size.quantity}-${size.name || size.size}${
					size.length ? ` /${size.length}` : ""
				}`;

				if (size.quantity !== 0 && size.quantity !== "") {
					// Use exact values from database without modification
					listOfSizes.push(sizeString.trim());
				}
			});

			return listOfSizes.join(", ");
		},

		renderSizesArray(sizeSelections, isSpecialSize) {
			let listOfSizes = [];

			sizeSelections.forEach((size) => {
				const sizeString = `${size.quantity}-${size.name || size.size}${
					size.length ? ` /${size.length}` : ""
				}`;

				if (size.quantity !== 0 && size.quantity !== "") {
					// Use exact values from database without modification
					listOfSizes.push(sizeString.trim());
				}
			});

			return listOfSizes;
		},

		/**
		 * Builds a map of sizeId -> sequence from the size chart
		 * @param {Object} sizeChart - The size chart object from lineItem
		 * @returns {Map<number, number>} Map of sizeId to sequence number
		 */
		buildSizeSequenceMap(sizeChart) {
			const idMap = new Map();
			const nameMap = new Map();
			if (!sizeChart || !sizeChart.sizes) {
				return { idMap, nameMap };
			}

			sizeChart.sizes.forEach(size => {
				const seq = size.sequence ?? 999;
				idMap.set(size.sizeId, seq);
				if (size.name) nameMap.set(size.name, seq);
			});

			return { idMap, nameMap };
		},

		/**
		 * Merges normal sizes and special sizes, sorts by size chart sequence then by length numerically.
		 * Sizes are displayed with format: quantity-sizeName/length (e.g., "1-YXS/16")
		 * @param {Object} lineItem - The line item containing sizeSelections, specialSizeSelections, and sizeChart
		 * @returns {Array} - Array of formatted size strings sorted by sequence and length
		 */
		mergeAndSortAllSizes(lineItem) {
			if (!lineItem) return [];

			// Build sequence lookup from size chart
			const { idMap, nameMap } = this.buildSizeSequenceMap(lineItem.sizeChart);

			// Mark normal vs special sizes and add sequence
			const normalSizes = (lineItem.sizeSelections || []).map(size => ({
				...size,
				isSpecial: false,
				sequence: idMap.get(size.sizeId) || 998
			}));

			const specialSizes = (lineItem.specialSizeSelections || []).map(size => ({
				...size,
				isSpecial: true,
				sequence: nameMap.get(size.name || size.size) ?? 999
			}));

			// Merge arrays
			const allSizes = [...normalSizes, ...specialSizes];

			// Filter out zero quantities
			const validSizes = allSizes.filter(size =>
				size.quantity !== 0 && size.quantity !== ""
			);

			// Sort by:
			// 1. Sequence (ascending) - respects size chart order
			// 2. Length (ascending, numeric) - within same size
			validSizes.sort((a, b) => {
				// Primary sort: sequence
				if (a.sequence !== b.sequence) {
					return a.sequence - b.sequence;
				}

				// Secondary sort: length (numeric)
				const lengthA = a.length ? parseInt(a.length, 10) : 0;
				const lengthB = b.length ? parseInt(b.length, 10) : 0;
				return lengthA - lengthB;
			});

			// Format sizes with proper trimming and no space before slash
			return validSizes.map(size => {
				const sizeName = size.name || size.size || '';
				const length = size.length ? `/${size.length}` : '';
				return `${size.quantity}-${sizeName}${length}`.trim();
			});
		},

		/**
		 * Renders the payment page URL as a PNG data URI for the invoice footer (#1472).
		 * Resolves (never rejects) so a QR failure still leaves the typed link printable.
		 */
		async generatePayQr() {
			if (this.printType !== "INVOICE") return;
			try {
				this.payQrDataUrl = await QRCode.toDataURL(PAYMENT_URL, {
					width: 160,
					margin: 1,
					errorCorrectionLevel: "M",
				});
			} catch (error) {
				console.error("[SalesPrintTemplate] Failed to generate payment QR code:", error);
				this.payQrDataUrl = null;
			}
		},

		generatePrintDoc() {
			//get Html to print
			let printHTML = document.querySelector(".print").parentElement.innerHTML;
			/* eslint-disable */
			// Use local PagedJS with CDN fallback for safety
			const pagedJsScript = pagedJSService.getPagedJSScriptTag({
				useLocal: true,
				inline: false,
				fallbackToCDN: true
			});

			const printDoc = `<!DOCTYPE html>
                <html>
                <head>
					${pagedJsScript}
					<script>
						class Sanitize extends Paged.Handler
						{
							constructor(chunker, polisher, caller) {
								super(chunker, polisher, caller);
							}

							afterPageLayout(pageFragment, page) {
								//console.log(pageFragment);
								const contentElements = document.querySelectorAll('.pagedjs_page_content');
                            	contentElements.forEach(element => {
									let style = element.getAttribute("style");
									if (style) {
										style = style.replace(/column-width:[^;]+;?/, '');
										element.setAttribute("style", style);
									}
                            	});
							}

							afterRendered(pages) {
								// Set completion flag for server-side PDF generation (PdfService.cs)
								window.__pagedjs_complete = true;

								// Fix "Page X of 0" - counter(pages) is unreliable in running elements.
								// Manually set the correct total page count in all .page-number elements.
								const totalPages = pages.length;
								document.querySelectorAll('.pagedjs_page').forEach((pageEl, index) => {
									const pageNumberEl = pageEl.querySelector('.page-number');
									if (pageNumberEl) {
										pageNumberEl.textContent = 'Page ' + (index + 1) + ' of ' + totalPages;
									}
								});
							}
						}
						Paged.registerHandlers(Sanitize);
					<\/script>
                    <style type="text/css">
                    *,::after,::before{box-sizing:border-box;margin:0;padding:0}
					body{counter-reset: page;overflow:hidden;overflow-y:scroll;}
					@page{size:Letter;margin:0.4cm;margin-top:3.5cm;margin-bottom:1.2cm; @top-center{content:element(pageHeader)} @bottom-center{content:element(pageIdFooter)}}
					#print-header{counter-increment: page;}
					#print-header:after{content:" " counter(page);left:0;top:100%;white-space:nowrap;z-index:100;}
					.print{height:100%;position:relative;background-color:#fff;line-height:14pt;font-family:Arial,sans-serif!important;width:100%}
					.print-wrapper{height:100%;display:flex;flex-direction:column}.print-heading{position:running(pageHeader);display:block;}
					.print-heading p{font-size:12pt;font-family:Arial, sans-serif;margin-bottom:8px!important}
					/* Clamp long School PO #s so the running header never outgrows the fixed 3.5cm @page margin box (PagedJS clips overflow top+bottom) - Issue #1142 */
					.print-heading p.school-po{font-size:10pt;line-height:12pt;margin-top:4px;margin-bottom:0!important;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2;overflow:hidden;word-break:break-word}
					.print-heading-logo{display:block;width:100%;text-align:center}
					.print-heading-logo img{max-width:70%;height:auto}
					.print-heading-type{display:inline-block;width:100%;padding:4px;margin-bottom:8px;text-align:center;font-size:14pt;background-color:#000;color:#fff}
					.print-heading-left{display:inline-block;width:25%;text-align:left;vertical-align:top}
					.print-heading-center{display:inline-block;width:50%;vertical-align:top}
					.print-heading-right{display:inline-block;font-family:Arial, sans-serif;width:25%;text-align:right;vertical-align:top}
					.print-info{display:flex;margin-bottom:8px;align-items:stretch;flex-wrap:wrap}.print-info-container-split{width:48%}
					.print-info-container-split:last-child{margin-left:4%}.print-info-container-split table{width:100%;height:100%;border-spacing:0px;font-size:10pt;border:1px solid #000}
					.print-info-container-split table thead tr{page-break-inside:avoid}
					.print-info-container-split table thead tr th{padding:4px;background-color:#000;color:#fff;text-align:center;font-weight:400}
					.print-info-container-split table tbody tr{page-break-inside:avoid;}
					.print-info-container-split table tbody tr td{padding:5px;padding-left:15px}
					.print-info-container-split table tbody tr td p.addr-city-state{margin-bottom:20px!important}
					.print-info-container-full{display:block;width:100%}
					.print-info-container-full table{width:100%;border-spacing:0px;font-size:10pt;border:1px solid #000}
					.print-info-container-full table thead tr{page-break-inside:avoid}
					.print-info-container-full table thead tr th{padding:4px;background-color:#000;color:#fff;text-align:center;font-weight:400}
					.print-info-container-full table tbody tr{page-break-inside:avoid}
					.print-info-container-full table tbody tr td{padding:4px;text-align:center;border-right:1px solid #000}
					.print-info-container-full table tbody tr td:last-child{border-right:none}
					.print-items{display:block; margin-bottom: 16px;}
					.print-items-shipped {font-size:10px;color: gray;text-wrap:nowrap;font-weight:700}
					.print-items-container{display:block;width:100%}					
					.print-items-container table{width:100%;border-spacing:0px;border:1px solid #000}
					.print-items-container table thead tr{page-break-inside:avoid}
					.print-items-container table thead tr th{font-size:10pt;padding:4px 2px;background-color:#000;color:#fff;text-align:center;font-weight:400}
					.print-items-container table tbody tr{page-break-inside:avoid;break-inside:avoid}
					.print-items-container table tbody tr td{font-size:9pt;vertical-align:top;padding:3px 2px;text-align:center;border-right:1px solid #000;line-height:15px}
					.print-items-container table tbody tr td:last-child{border-right:none}
					.print-items-container table tbody tr td:nth-child(1){width:50px}
					.print-items-container table tbody tr td:nth-child(2){width:16%}
					.print-items-container table tbody tr td:nth-child(3){text-align:left}
					.print-items-container table tbody tr td:nth-child(4){width:8%}
					.print-items-container table tbody tr td:nth-child(5){width:8%}
					.print-items-container table tbody tr td:nth-child(6){text-align:right}
					.print-items-container table tbody tr td:nth-child(7){text-align:right}
					.print-items-title{font-weight:700}.print-items-value{font-weight:700}
					.size-item{display:inline-block;white-space:pre}
					.page-id-footer{position:running(pageIdFooter);font-family:Arial,sans-serif;font-size:9pt;color:#555;text-align:center;padding:4px 0}
					.page-id-footer .page-number::after{content:none}
                    </style>
					<style type="text/css">


					.print-rep-prices-table {
						page-break-inside: avoid;
					}
					.print-pay-online {
						display: flex;
						align-items: center;
						gap: 8px;
						margin-top: 8px;
						page-break-inside: avoid;
						break-inside: avoid;
					}
					.print-pay-online-qr {
						display: block;
						width: 0.85in;
						height: 0.85in;
					}
					.print-pay-online-text {
						font-size: 9pt;
						line-height: 12pt;
					}
					.print-pay-online-text p {
						margin: 0;
					}
					.print-pay-online-title {
						font-size: 10pt;
						font-weight: 700;
					}
					.print-pay-online a {
						color: #000;
						text-decoration: underline;
					}
					.print-table-price table{
						width: 100%;
						border-spacing: 0px;
						font-size: 7pt;
						min-width: 250px;
						page-break-inside: avoid;
					}
					.print-table-price-rowLabel {
						background-color: #fff;
						color: #000;
						font-weight: 400;
					}
					.print-table-price table tbody tr {
						page-break-inside: avoid;
					}
					.print-table-price tr {
						border: 1px solid #000;
					}
					.print-table-price td {
						padding: 0 2px;
						border: 1px solid #000;
					}

					.print-payments {
						margin-top: 8px;
					}
					.print-payments-table{
						width: 100%;
						border-spacing: 0px;
						font-size: 7pt;
						border: 1px solid #000;
						min-width: 250px;
					}
					.print-payments-table tr {
						border: 1px solid #000;
					}
					.print-payments-table td {
						padding: 0 2px;
						border: 1px solid #000;
					}
					.print-payments-table th {
						background-color: black;
						color: white;
						border: 1px solid #000;
					}
					</style>
                </head>
                <body>
                    ${printHTML}
                </body>
                </html>`;

			//render printDoc in iframe
			document.getElementById("print-frame").setAttribute("srcdoc", printDoc);

			return printDoc;
		},

		async download() {
			this.isDownloading = true;

			try {
				await this.payQrReady;
				const printDoc = this.generatePrintDoc();

				const r = await this.$http.post("api/document", printDoc, {
					headers: {
						"Content-Type": "text/html",
					},
				});

				const documentId = r.data.docId;

				const docType = this.isQuote ? "quote" : "sales-order";
				const docNumber = this.isQuote ? this.printInfo.quoteNumber : this.printInfo.orderNumber;
				const downloadUrl = `/api/document/${documentId}?type=${docType}&id=${docNumber}`;

				window.open(downloadUrl);

				this.snackbar = {
					show: true,
					message: `${this.isQuote ? 'Quote' : 'Sales Order'} #${docNumber} downloaded successfully`,
					color: 'success',
					timeout: 5000,
				};
			} catch (error) {
				console.error("Error downloading document:", error);
				this.snackbar = {
					show: true,
					message: "Failed to download document. Please try again.",
					color: 'error',
					timeout: 5000,
				};
			} finally {
				this.isDownloading = false;
			}
		},

		async print() {
			this.isPrinting = true;
			this.printResult = {
				show: false,
				type: "success",
				message: "",
			};

			try {
				// Form validation
				if (!this.isFormValid) {
					if (!this.printerSelection) {
						this.printResult = {
							show: true,
							type: "error",
							message: "Please select a printer",
						};
					} else if (!this.copies || this.copies <= 0) {
						this.printResult = {
							show: true,
							type: "error",
							message: "Please enter a valid number of copies",
						};
					}
					this.isPrinting = false;
					return;
				}

				// Generate the print document
				await this.payQrReady;
				const printDoc = this.generatePrintDoc();

				// Get document ID by submitting to the API
				const documentResponse = await this.$http.post("api/document", printDoc, {
					headers: {
						"Content-Type": "text/html",
					},
				});

				const documentId = documentResponse.data.docId;

				// Create print options
				const printOptions = {
					copies: parseInt(this.copies, 10),
					color: false,
					duplex: false,
					collate: true,
					paperSize: "letter",
				};

				// Add metadata for print job logging
				const metadata = {
					documentType: this.isQuote ? 1 : 2, // 1 = Quote, 2 = SalesOrder (from enum)
					documentNumber: this.isQuote ? this.printInfo.quoteNumber : this.printInfo.orderNumber,
					quoteId: this.isQuote ? this.printInfo.quoteId : null,
					salesOrderId: !this.isQuote ? this.printInfo.salesOrderId : null,
					message: this.printMessage,
				};

				// Send the print job request
				const printResponse = await this.$http.post(
					`/api/print/document`,
					{
						documentId: documentId,
						printerId: this.printerSelection,
						options: printOptions,
						metadata: metadata,
					}
				);

				// Set the print job ID and show success message
				// Handle responses that might not have expected structure
				if (printResponse && printResponse.data) {
					this.printJobId = printResponse.data.jobId || "unknown";
				} else {
					this.printJobId = "unknown";
				}

				// Show success message in both the alert and snackbar
				const docType = this.isQuote ? "Quote" : "Sales Order";
				const docNumber = this.isQuote ? this.printInfo.quoteNumber : this.printInfo.orderNumber;
				const printerName =
					this.printers.find((p) => p.printerId === this.printerSelection)?.text ||
					"selected printer";

				this.printResult = {
					show: true,
					type: "success",
					message: `${docType} #${docNumber} successfully sent to ${printerName}`,
				};

				// Display snackbar notification instead of toast
				this.snackbar = {
					show: true,
					color: "success",
					text: this.printResult.message,
					timeout: 5000,
				};

				// Log success details
				try {
					console.log("Print job sent successfully", {
						documentId,
						printerId: this.printerSelection,
						copies: this.copies,
						message: this.printMessage,
						jobId: this.printJobId,
						documentType: this.printType,
						documentNumber: docNumber,
					});
				} catch (logError) {
					console.error("Error logging print job details:", logError);
				}

				// Only hide the modal after a short delay to allow users to see the success message
				setTimeout(() => {
					this.showPrintModal = false;
					this.isPrinting = false;
				}, 2000);
			} catch (error) {
				console.error("Error printing document:", error);

				// Handle different error types with a safe extraction of error message
				let errorMessage = "Unknown error occurred";
				try {
					if (error.response && typeof error.response.data === "string") {
						errorMessage = error.response.data;
					} else if (error.message) {
						errorMessage = error.message;
					}
				} catch (e) {
					console.error("Error extracting error message:", e);
				}

				this.printResult = {
					show: true,
					type: "error",
					message: `Print failed: ${errorMessage}`,
				};

				// Display snackbar notification instead of toast
				this.snackbar = {
					show: true,
					color: "error",
					text: this.printResult.message,
					timeout: 5000,
				};

				this.isPrinting = false;
			}
		},

		formatNewLines(text) {
			if (!text) return "";
			return text.replace(/\n/g, "<br/>").replace(/\t/g, "&emsp;");
		},

		mergeAndSortSelections(lineItem) {
			// Merge colorSelections and freeTextSelections. Dedupe because a free text
			// can arrive via both arrays when the item was edited in-session (#1431)
			const mergedSelections = dedupeSelections([
				...(lineItem.colorSelections || []),
				...(lineItem.freeTextSelections || []).map((selection) => ({
					...selection,
					colorName: selection.text, // Using 'text' as 'colorName' for display purposes
				})),
			]);

			const mappedWithPosition = mergedSelections.map((selection) => {
				const colorOption = lineItem.colorOptions.find(
					(option) => option.colorOptionId === selection.colorOptionId
				);
				return {
					...selection,
					position: colorOption ? colorOption.position : null,
				};
			});

			const sortedSelections = mappedWithPosition.sort(
				(a, b) => (a.position || 0) - (b.position || 0)
			);

			return sortedSelections;
		},
	},
	computed: {
		isFormValid() {
			return this.printerSelection && this.copies && this.copies > 0;
		},
		dateLabel() {
			return this.isQuote ? 'Quote Date' : 'Order Date';
		},
		displayDate() {
			// For quotes: show orderDate if processed, otherwise show createdAt
			// For orders: always show orderDate
			if (this.isQuote) {
				// If quote has been processed into an order, show the orderDate
				if (this.printInfo.orderNumber && this.printInfo.orderDate) {
					return this.printInfo.orderDate;
				}
				// Otherwise show when the quote was created
				return this.printInfo.createdAt;
			}
			// For orders, always show orderDate
			return this.printInfo.orderDate;
		},
		computedItemsTable() {
			let itemsArr = [];

			if (this.printInfo.items && this.printInfo.items.length > 0) {
				//loop through all level 1 items and add them to the itemsArr and check for child items
				this.printInfo.items.forEach((item) => {
					itemsArr.push({
						...item,
						_isChild: false,
						mergedSortedSizes: this.mergeAndSortAllSizes(item)
					});

					if (item.children && item.children.length > 0) {
						//loop through all level 2 items and add them to the itemsArr and check for sub child items
						item.children.forEach((childItem) => {
							itemsArr.push({
								...childItem,
								_isChild: true,
								mergedSortedSizes: this.mergeAndSortAllSizes(childItem)
							});

							if (childItem.children && childItem.children.length > 0) {
								//loop through all level 3 items and add them to the itemsArr
								childItem.children.forEach((sub) => {
									itemsArr.push({
										...sub,
										_isChild: true,
										mergedSortedSizes: this.mergeAndSortAllSizes(sub)
									});
								});
							}
						});
					}
				});
			}
			return itemsArr;
		},
		computedOrderContact() {
			let contact = {
				name: "",
				email: "",
				cellPhoneNumber: "",
				workPhoneNumber: "",
			};

			let customer = null;

			if (this.printInfo.quoteCustomer) {
				customer = this.printInfo.quoteCustomer;
			}
			if (this.printInfo.customer) {
				customer = this.printInfo.customer;
			}

			if (this.printInfo.contactId && customer) {
				const contactObj = customer.customer.contacts.find(
					(contact) => contact.contactId == this.printInfo.contactId
				);
				if (contactObj) {
					contact.name = `${contactObj.firstName} ${contactObj.lastName}`;
					contact.email = contactObj.email;
					contact.cellPhoneNumber = contactObj.cellPhoneNumber;
					contact.workPhoneNumber = contactObj.workPhoneNumber;
				}
			}

			return contact;
		},
		resolveCustomer() {
			if (this.printInfo.quoteCustomer) return this.printInfo.quoteCustomer;
			if (this.printInfo.customer) return this.printInfo.customer;
			return null;
		},
		computedAddress() {
			let result = {
				address: "",
				cityState: "",
				contactName: "",
				contactEmail: "",
				contactWorkPhone: "",
				contactCellPhone: "",
				organization: "",
				department: "",
			};

			const customer = this.resolveCustomer;
			if (!customer) return result;

			// Find Bill To address by billToId, fall back to primary, then first
			let addressObj = this.printInfo.billToId
				? customer.customer.addresses.find(a => a.addressId == this.printInfo.billToId)
				: null;

			if (!addressObj) {
				addressObj = customer.customer.addresses.find(a => a.isPrimaryAddress == true)
					|| (customer.customer.addresses.length > 0 ? customer.customer.addresses[0] : null);
			}

			if (addressObj) {
				result.address = `${addressObj.addressLine1 || ''} ${addressObj.addressLine2 || ''}`.trim();
				result.cityState = `${addressObj.city || ''}, ${addressObj.state || ''} ${addressObj.postalCode || ''}`;
				result.organization = addressObj.organization || '';
				result.department = addressObj.department || '';

				// Resolve contact: address-level first, then order-level fallback
				if (addressObj.contact) {
					result.contactName = `${addressObj.contact.firstName} ${addressObj.contact.lastName}`.trim();
					result.contactEmail = addressObj.contact.email || '';
					result.contactWorkPhone = addressObj.contact.workPhoneNumber || '';
					result.contactCellPhone = addressObj.contact.cellPhoneNumber || '';
				} else if (addressObj.contactId && customer.customer.contacts) {
					const c = customer.customer.contacts.find(c => c.contactId == addressObj.contactId);
					if (c) {
						result.contactName = `${c.firstName} ${c.lastName}`.trim();
						result.contactEmail = c.email || '';
						result.contactWorkPhone = c.workPhoneNumber || '';
						result.contactCellPhone = c.cellPhoneNumber || '';
					}
				}

				// Fall back to order-level contact
				if (!result.contactName) {
					const fallback = this.computedOrderContact;
					result.contactName = fallback.name;
					result.contactEmail = fallback.email;
					result.contactWorkPhone = fallback.workPhoneNumber;
					result.contactCellPhone = fallback.cellPhoneNumber;
				}
			}

			return result;
		},
		computedShipTo() {
			let result = {
				address: "",
				cityState: "",
				contactName: "",
				contactEmail: "",
				contactWorkPhone: "",
				contactCellPhone: "",
				organization: "",
			};

			const customer = this.resolveCustomer;
			if (!customer) return result;

			const addressObj = customer.customer.addresses.find(
				a => a.addressId == this.printInfo.shipToId
			);

			if (addressObj) {
				result.address = `${addressObj.addressLine1 || ''} ${addressObj.addressLine2 || ''}`.trim();
				result.cityState = `${addressObj.city || ''}, ${addressObj.state || ''} ${addressObj.postalCode || ''}`;
				result.organization = addressObj.organization || '';

				// Resolve contact: address-level first, then order-level fallback
				if (addressObj.contact) {
					result.contactName = `${addressObj.contact.firstName} ${addressObj.contact.lastName}`.trim();
					result.contactEmail = addressObj.contact.email || '';
					result.contactWorkPhone = addressObj.contact.workPhoneNumber || '';
					result.contactCellPhone = addressObj.contact.cellPhoneNumber || '';
				} else if (addressObj.contactId && customer.customer.contacts) {
					const c = customer.customer.contacts.find(c => c.contactId == addressObj.contactId);
					if (c) {
						result.contactName = `${c.firstName} ${c.lastName}`.trim();
						result.contactEmail = c.email || '';
						result.contactWorkPhone = c.workPhoneNumber || '';
						result.contactCellPhone = c.cellPhoneNumber || '';
					}
				}

				// Fall back to order-level contact
				if (!result.contactName) {
					const fallback = this.computedOrderContact;
					result.contactName = fallback.name;
					result.contactEmail = fallback.email;
					result.contactWorkPhone = fallback.workPhoneNumber;
					result.contactCellPhone = fallback.cellPhoneNumber;
				}
			}

			return result;
		},
		printedBy() {
			let user = this.$store.getters.userInfo;

			// Use initials instead of full name (Issue #1123)
			if (user?.initials) {
				return `by ${user.initials}`;
			} else if (user?.firstName && user?.lastName) {
				return `by ${(user.firstName[0] + user.lastName[0]).toUpperCase()}`;
			} else if (user?.username) {
				return `by ${user.username.substring(0, 2).toUpperCase()}`;
			}

			return "";
		},
	},
	async mounted() {
		// the quote/order view keeps its scroll position when routing to the print preview
		window.scrollTo(0, 0);

		// Kick off the payment QR image; print/download and the preview await it so the
		// serialized document always contains the <img> (#1472)
		this.payQrReady = this.generatePayQr();

		//need to delay generation so that all data has time to fully load before we generate iframe doc
		this.payQrReady.then(() => this.$nextTick(() => this.generatePrintDoc()));

		// Load printers from API
		try {
			const response = await this.$http.get(`/api/print/printers`);
			const printersData = response.data.printers || response.data;
			this.printers = printersData.map((printer) => ({
				printerId: printer.id,
				text: `${printer.name} (${printer.location || "No location"})`,
				status: printer.status,
			}));

			// Set default values for print modal
			if (this.printers.length > 0) {
				const onlinePrinter = this.printers.find((p) => p.status === "Online");
				this.printerSelection = onlinePrinter
					? onlinePrinter.printerId
					: this.printers[0].printerId;
			}
			this.copies = 1;
		} catch (error) {
			console.error("Error loading printers:", error);
		}
	},
};
</script>

<style lang="scss" scoped>
#print-frame {
	position: relative;
	background-color: $color-white;
	width: 100%;
	max-width: 832px;
	min-height: 1056px;
	margin: auto;
	border: none;
}

// keep the action buttons visible below the fixed app bar while scrolling the document
.actions-col {
	position: sticky;
	top: 64px;
	z-index: 4;
	background-color: $color-gray-light;

	@media (max-width: 959px) {
		top: 56px;
	}
}

.actions {
	display: flex;
	width: 100%;
	justify-content: flex-end;

	.v-btn {
		background-color: $color-white;
		border-color: $color-gray;
		text-transform: initial;

		&:not(:last-child) {
			margin-right: 0.8rem;
		}
	}
}

.print-modal {
	&-form {
		display: flex;
		flex-flow: column wrap;

		.form-input {
			margin: 0.75rem 0;

			.number-input {
				width: 14rem;
				flex: initial;
			}
		}
	}
}

.input-modal-content-actions {
	display: flex;
	justify-content: flex-end;
	margin-top: 1rem;
}

.message-input {
	width: 100%;
}

.print {
	position: relative;
	background-color: $color-white;
	line-height: 14pt;
	font-family: Arial, sans-serif !important;
	width: 100%;
	//remove for printing css
	max-width: 816px;
	min-height: 1056px;
	margin: auto;
	padding: 0.6cm;

	&-wrapper {
		height: 100%;
	}

	&-heading {
		display: block;
		margin-bottom: 12px;

		p {
			font-size: 12pt;
			margin-bottom: 8px !important;
		}

		&-logo {
			display: block;
			width: 100%;
			text-align: center;

			img {
				max-width: 70%;
				height: auto;
			}
		}

		&-type {
			display: inline-block;
			width: 100%;
			padding: 8px;
			margin-bottom: 8px;
			text-align: center;
			font-size: 14pt;
			background-color: $color-black;
			color: $color-white;
		}

		&-left {
			display: inline-block;
			width: 25%;
			text-align: left;
			vertical-align: top;
		}

		&-center {
			display: inline-block;
			width: 50%;
			vertical-align: top;
		}

		&-right {
			display: inline-block;
			width: 25%;
			text-align: right;
			vertical-align: top;
		}
	}

	&-info {
		display: block;
		margin-bottom: 8px;

		&-container-split {
			display: inline-block;
			width: 48%;

			&:last-child {
				margin-left: 4%;
			}

			table {
				width: 100%;
				border-spacing: 0px;
				font-size: 11pt;
				border: 1px solid $color-black;

				thead {
					tr {
						page-break-inside: avoid;

						th {
							padding: 8px;
							background-color: $color-black;
							color: $color-white;
							text-align: center;
							font-weight: normal;
						}
					}
				}

				tbody {
					tr {
						page-break-inside: avoid;

						td {
							padding: 20px;
							padding-left: 50px;

							p:nth-child(4) {
								margin-bottom: 20px !important;
							}
						}
					}
				}
			}
		}

		&-container-full {
			display: block;
			width: 100%;

			table {
				width: 100%;
				border-spacing: 0px;
				font-size: 11pt;
				border: 1px solid $color-black;

				thead {
					tr {
						page-break-inside: avoid;

						th {
							padding: 8px;
							background-color: $color-black;
							color: $color-white;
							text-align: center;
							font-weight: normal;
						}
					}
				}

				tbody {
					tr {
						page-break-inside: avoid;

						td {
							padding: 8px;
							text-align: center;
							border-right: 1px solid $color-black;

							&:last-child {
								border-right: none;
							}
						}
					}
				}
			}
		}
	}

	&-items {
		display: block;

		&-container {
			display: block;
			width: 100%;

			table {
				width: 100%;
				border-spacing: 0px;
				border: 1px solid $color-black;

				thead {
					tr {
						page-break-inside: avoid;

						th {
							font-size: 11pt;
							padding: 4px 2px;
							background-color: $color-black;
							color: $color-white;
							text-align: center;
							font-weight: normal;
						}
					}
				}

				tbody {
					tr {
						page-break-inside: avoid;

						td {
							font-size: 10pt;
							vertical-align: top;
							padding: 4px;
							text-align: center;
							border-right: 1px solid $color-black;

							&:last-child {
								border-right: none;
							}

							&:nth-child(1) {
								width: 50px;
							}

							&:nth-child(2) {
								width: 16%;
							}

							&:nth-child(3) {
								text-align: left;
							}

							&:nth-child(4) {
								width: 8%;
							}

							&:nth-child(5) {
								width: 8%;
							}

							&:nth-child(6) {
								text-align: right;
							}

							&:nth-child(7) {
								text-align: right;
							}
						}
					}
				}
			}
		}

		&-title {
			font-weight: 700;
		}

		&-value {
			font-weight: 700;
		}
	}
}

.size-item {
	display: inline-block;
	white-space: pre;
}

.button-group {
	display: flex;
	align-items: center;
}
</style>
